import { CSSProperties, memo } from 'react';

import Link from '~/shared/components/Link/Link';
import { Text } from '~/shared/components/Text/Text';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import styles from './searchDialogContent.module.css';

export const PopularCategoriesLinks = memo(() => {
	const { data: frame } = useFrame();
	const { translate } = useTranslation();
	const itemCount = frame.search?.popularCategoriesLinks?.length;

	if (!frame.search?.popularCategoriesLinks) {
		return null;
	}

	return (
		<div
			className={styles.popularCategoriesLinksArea}
			aria-live="polite"
		>
			<Text
				className={styles.listLabel}
				as="h3"
				variant="bodySm"
				id="popular-category-links"
			>
				{translate('search.popular-category-links')}
			</Text>
			<ul
				className={styles.popularCategoriesList}
				style={{ '--item-count': itemCount ? Math.ceil(itemCount / 2) : undefined } as CSSProperties}
			>
				{frame.search?.popularCategoriesLinks.map((link) => (
					<li key={`popular-category-link-${link.id}`}>
						<Link
							title={link.title}
							href={link.url}
						>
							{link.text}
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
});
